import { HardwareSupplierFilterKeyType } from 'pages/ordering/type'

interface Props {
  hardwareSupplier?: HardwareSupplierFilterKeyType
}

// TODO this should probably go in the Config.
export const REGISTER_LINK_MAPPING = {
  outlet: 'https://app.opensolar.com/expo/solaroutlet/au#get-started',
  city_plumbing: 'https://share.hsforms.com/1ArJCBRFsSReMQzJtbzqw7gcne2p',
}

const RegisterLink: React.FC<Props> = ({ hardwareSupplier = 'outlet' }) => {
  const registerLink = REGISTER_LINK_MAPPING[hardwareSupplier]

  if (!registerLink || hardwareSupplier === 'city_plumbing') {
    return null
  }

  return (
    <span>
      (
      <a href={registerLink} target="_blank" rel="noreferrer">
        Register
      </a>
      ) to view pricing and stock availability
    </span>
  )
}

export default RegisterLink
